export const getImage = (imgSizeList = {}, targetSize) => {
  const sizes = ['small', 'medium', 'big', 'large', 'extralarge', 'extraLarge'];
  if (!sizes.includes(targetSize)) {
    return null;
  }

  const priorityList = [
    ...sizes.slice(sizes.indexOf(targetSize)),
    ...sizes.slice(0, sizes.indexOf(targetSize)).reverse(),
  ];

  return imgSizeList[priorityList.find(key => imgSizeList[key])] || null;
};
